import React from 'react';
import { MessageCircle } from 'lucide-react';
import FadeIn from './FadeIn';

const WHATSAPP_URL = 'https://wa.me/919902506684?text=Hi%2C%20I%20want%20to%20place%20a%20grocery%20order';

export default function CTA() {
  return (
    <section className="section-spacing relative overflow-hidden">
      {/* Green gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1B4332] via-[#2D6A4F] to-[#40916C]"></div>

      <div className="content-width text-center relative z-10">
        <FadeIn>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white tracking-tight">
            Start Your First Order Today
          </h2>
        </FadeIn>
        <FadeIn delay={0.1}>
          <p className="mt-4 text-white/80 text-lg leading-relaxed max-w-md mx-auto">
            Send your grocery list on WhatsApp and let us take care of everything.
          </p>
        </FadeIn>
        <FadeIn delay={0.2}>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 bg-white text-primary font-semibold px-8 py-4 rounded-lg text-base hover:bg-secondary hover:scale-[1.02] transition-all inline-flex items-center gap-2 shadow-lg"
          >
            <MessageCircle className="h-5 w-5" />
            Order on WhatsApp
          </a>
        </FadeIn>
      </div>
    </section>
  );
}
